module.exports = __webpack_public_path__ + "media/images/BVIULogo-6f45d97fd58f1799b580f50d025e5e8c.png";